import { MarkerClusterer } from "@googlemaps/markerclusterer"
// import Alpine from "alpinejs"

const locations = () => {
    const $locationTriggers = $(`.locations__item .accordion__trigger`);

    let $location,
        location,
        open,
        url,
        params;

    const addQueryParam = (key, value) => {
        url = new URL(window.location.href);
        url.searchParams.set(key, value);
        window.history.pushState({}, "", url.toString());
    };

    const getLocationParam = () => {
        location = new URL(document.location).searchParams.get("id");

        if (location) {
            $(`#location-${location}`)[0].scrollIntoView();
        }
    }

    $locationTriggers.on("click", ({ currentTarget }) => {
        $location = $(currentTarget).closest(`.accordion`);
        open = $location.hasClass("open");

        addQueryParam("id", open ? "" : $location.attr("id").replace("location-", ""));
    });

    setTimeout(getLocationParam, 1000);
}

$(locations);


// Gmaps:
(g=>{var h,a,k,p="The Google Maps JavaScript API",c="google",l="importLibrary",q="__ib__",m=document,b=window;b=b[c]||(b[c]={});var d=b.maps||(b.maps={}),r=new Set,e=new URLSearchParams,u=()=>h||(h=new Promise(async(f,n)=>{await (a=m.createElement("script"));e.set("libraries",[...r]+"");for(k in g)e.set(k.replace(/[A-Z]/g,t=>"_"+t[0].toLowerCase()),g[k]);e.set("callback",c+".maps."+q);a.src=`https://maps.${c}apis.com/maps/api/js?`+e;d[q]=f;a.onerror=()=>h=n(Error(p+" could not load."));a.nonce=m.querySelector("script[nonce]")?.nonce||"";m.head.append(a)}));d[l]?console.warn(p+" only loads once. Ignoring:",g):d[l]=(f,...n)=>r.add(f)&&u().then(()=>d[l](f,...n))})({
	key: window.GMAPS_PUBLIC_API_KEY,
	v: "weekly",
	libraries: ["places", "core","geometry","geocoding"],
})

let pagemap;
let infoWindow;
const SA_BOUNDS = {
	"south": -38.0659,
	"west": 129.0000,
	"north": -25.9960,
	"east": 141.0028
};
let availableTags  = [];
/*** TODO:
DONT WANTED TO DO HADD TO DO (MOVE TO CMS IF POSSIBLE)
Last updated: https://www.matthewproctor.com/australian_postcodes (Maintainer)
*/
fetch('/dist/aus_postcode.json').then(res=> res.json()).then(data=>{
	availableTags = data;
})

const locationMap = (overrideData) => ({
	loadingdata: true,
	pageDataSearchLoading:false,
	suburbInput:'',
    location: null,
    type: null,
	sessionToken:  null,
    stateCentres: {
		SA: { lat: -34.9275, lng: 138.6 },
	},
	serviceType:'all',
	layout:"map",
	markers: [],
	markersMapped: [],
	markersMappedForSidebar: [],
	markerCluster: null,
	fixedlocations:[],
	upcomingmobilelocations:[],
	othermobilelocations:[],
	data:[],
	// Clinic slug from a deep-link URL (e.g. `/our-locations/hampstead`). When
	// set, the matching clinic card is auto-expanded once the data renders and
	// the map is centred on it once the markers are ready. See init().
	pendingClinicSlug: null,
	autocompleteShowPredictions:false,
	autocompletePredictions: null,

	async getData() {
      try {
		 this.loadingdata = true
		  const searchparams = new URLSearchParams();
        if(this.location != null){
            searchparams.set('location', this.location);
        }
		 if(this.serviceType != 'all'){
            searchparams.set('type', this.serviceType);
        }
        const results = await fetch(`/api/locations?${searchparams.toString()}`)
			.then((response) => response.json())
			.then((json) => {
				return json
			});

		let fixedlocationArr = results?.fixed?.data ?? [];
		let othermobilelocationArr = results?.othermobilelocations?.data ?? [];
		let upcomingmobilelocationArr = results?.upcomingmobilelocations?.data ?? [];
		// updated to work with service type filter
		if(this.serviceType == 'mobile'){
			this.fixedlocations = [];
			this.othermobilelocations = othermobilelocationArr;
			this.upcomingmobilelocations = upcomingmobilelocationArr;
		}else if(this.serviceType == 'fixed'){
			this.fixedlocations = fixedlocationArr;
			this.othermobilelocations = [];
			this.upcomingmobilelocations = [];
		}else{
			this.fixedlocations = fixedlocationArr;
			this.othermobilelocations = othermobilelocationArr;
			this.upcomingmobilelocations = upcomingmobilelocationArr;
		}

		// Build the ordered list rendered by the UI. Without a search it stays
		// grouped (fixed -> current mobile -> other mobile) in alphabetical
		// order; with an active suburb/postcode search fixed and current-date
		// mobile clinics are merged and ranked by distance. See
		// buildOrderedData() for the full ordering rules. NOTE: do not re-sort
		// this.data elsewhere — a flat sort would break the grouping.
		this.buildOrderedData();
	  } catch (error) {

	  }finally{
          this.loadingdata = false
	  }
	},

	// Combines the location groups into the single ordered list rendered by
	// both the list view and the map sidebar.
	//
	// No search active (default): preserve the server's alphabetical (title ASC)
	// order within a fixed grouping:
	//   fixed -> upcoming mobile (dates within ~3 months) -> other mobile with
	//   confirmed screening dates -> other mobile with only an indicative date.
	//
	// Suburb/postcode search active (suburb coordinates known): rank by distance
	// to the searched location instead of by group. Every clinic that has
	// current/confirmed dates is merged into a single distance-ranked group so
	// the nearest currently-dated option leads regardless of whether it is
	// fixed or mobile. That group is:
	//   - all fixed clinics, plus
	//   - upcoming mobile clinics (screening dates within the ~3 month window),
	//     plus
	//   - any other mobile clinic that still has confirmed screening dates
	//     (datesConfirmed) even though its dates fall outside that window.
	// e.g. a search for Northfield surfaces the Hampstead mobile clinic (which
	// has confirmed dates but is not in the upcoming window) ahead of the
	// Modbury/Arndale/Adelaide fixed clinics. The remaining mobile clinics —
	// those with only an indicative (unconfirmed) date — follow as a second
	// group, also ordered by distance.
	buildOrderedData() {
		const hasSearch =
			this.location != null &&
			this.suburbLat != null &&
			this.suburbLng != null;

		const orderGroup = (arr) => {
			if (!hasSearch) return arr;
			return [...arr].sort((a, b) => {
				let aDistance = this._getDistanceFromCard(a);
				let bDistance = this._getDistanceFromCard(b);
				// Push entries without coordinates to the end of their group.
				if (isNaN(aDistance)) aDistance = Infinity;
				if (isNaN(bDistance)) bDistance = Infinity;
				return aDistance - bDistance;
			});
		};

		// Split the "other" mobile clinics into those with confirmed screening
		// dates and those with only an indicative (unconfirmed) date.
		const otherConfirmed = this.othermobilelocations.filter(
			(c) => c.datesConfirmed
		);
		const otherUnconfirmed = this.othermobilelocations.filter(
			(c) => !c.datesConfirmed
		);

		if (hasSearch) {
			// Group 1 — every clinic with current/confirmed dates (fixed +
			// upcoming mobile + other confirmed-date mobile), ranked purely by
			// distance so the closest currently-dated option leads.
			// Group 2 — the remaining indicative-only mobile clinics, also by
			// distance.
			this.data = [
				...orderGroup([
					...this.fixedlocations,
					...this.upcomingmobilelocations,
					...otherConfirmed,
				]),
				...orderGroup(otherUnconfirmed),
			];
		} else {
			this.data = [
				...this.fixedlocations,
				...this.upcomingmobilelocations,
				...otherConfirmed,
				...otherUnconfirmed,
			];
		}
	},

	async initMap(Map, mapEL, isStaticMap = false, args) {
		const mapArgs = {
			center: this.stateCentres.SA,
			zoom: args?.zoom || 10,
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			mapTypeControl: false,
			streetViewControl: false,
			mapId: "6f456ac5aa8546ebb9837c46",
			...args,
		}
		// const staticMarkers =
		// 	mapEL.querySelectorAll(".marker") || []
		let map = new Map(mapEL, mapArgs);
		// Add overlay
		const pinLegendOverlay = document.createElement("div");
		pinLegendOverlay.innerHTML = `
			<ul class="pinlegnds">
				<li>
				<span>
				<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
				<rect width="40" height="40" rx="20" fill="#E2A4DF"/>
				<path d="M20.0002 9.5001C16.3771 9.5001 13.4326 12.4076 13.4326 15.9433C13.4326 18.1525 14.245 20.6749 15.5458 22.9009C14.3391 23.2002 13.3091 23.6224 12.5203 24.1463C11.6176 24.7466 11 25.5297 11 26.4432C11 27.0882 11.3126 27.683 11.8057 28.1733C12.2989 28.6636 12.9783 29.07 13.7897 29.4112C15.4126 30.0936 17.5924 30.5 20 30.5C22.4076 30.5 24.5874 30.0936 26.2103 29.4112C27.0217 29.07 27.7011 28.6636 28.1943 28.1733C28.6874 27.683 29 27.0882 29 26.4432C29 25.3898 28.198 24.5257 27.0464 23.8853C26.9343 23.8107 26.7956 23.7855 26.6635 23.8163C26.5315 23.847 26.4184 23.93 26.3509 24.0456C26.2844 24.1612 26.2692 24.2991 26.311 24.4259C26.3519 24.5527 26.445 24.6562 26.5676 24.713C27.5614 25.2658 28.027 25.8829 28.027 26.4431C28.027 26.7871 27.8636 27.1357 27.4949 27.5021C27.1263 27.8684 26.559 28.232 25.8302 28.5387C24.3717 29.152 22.2946 29.5454 19.9999 29.5454C17.7051 29.5454 15.628 29.1521 14.1695 28.5387C13.4407 28.232 12.8735 27.8684 12.5048 27.5021C12.1361 27.1357 11.9727 26.7871 11.9727 26.4431C11.9727 25.9565 12.3157 25.4364 13.0673 24.9368C13.7799 24.4632 14.8289 24.0437 16.085 23.7585C17.1074 25.2919 18.354 26.6343 19.7261 27.5542C19.8915 27.6642 20.1081 27.6642 20.2734 27.5542C23.81 25.1828 26.5674 20.0269 26.5674 15.9432C26.5674 12.4075 23.6229 9.5 19.9998 9.5L20.0002 9.5001ZM20.0002 10.4546C23.094 10.4546 25.5948 12.9267 25.5948 15.9433C25.5948 19.4798 23.0512 24.3189 20.0002 26.5478C16.9492 24.319 14.4056 19.4801 14.4056 15.9433C14.4056 12.9267 16.9064 10.4546 20.0002 10.4546ZM20.0002 12.3637C17.9906 12.3637 16.3515 13.9717 16.3515 15.9433C16.3515 17.9148 17.9906 19.5228 20.0002 19.5228C22.0098 19.5228 23.6489 17.9148 23.6489 15.9433C23.6489 13.9717 22.0098 12.3637 20.0002 12.3637ZM20.0002 13.3183C21.4834 13.3183 22.6759 14.4881 22.6759 15.9433C22.6759 17.3984 21.4834 18.5683 20.0002 18.5683C18.517 18.5683 17.3245 17.3984 17.3245 15.9433C17.3245 14.4881 18.517 13.3183 20.0002 13.3183ZM25.3516 23.1023C25.0827 23.1023 24.8651 23.3158 24.8651 23.5796C24.8651 23.8434 25.0827 24.0569 25.3516 24.0569C25.6205 24.0569 25.8381 23.8434 25.8381 23.5796C25.8381 23.3158 25.6205 23.1023 25.3516 23.1023Z" fill="#63313C"/>
				</svg>
				</span>
				<span class="text">Fixed Location</span>
				</li>
				<li>
				<span>
					<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
					<rect width="40" height="40" rx="20" fill="#D71F85"/>
					<path d="M7.30748 25.2481H9.53962C9.71031 26.0945 10.3635 26.7605 11.2071 26.9464C12.0497 27.1334 12.9239 26.8043 13.4349 26.1098C13.9459 26.8043 14.8201 27.1334 15.6626 26.9464C16.5062 26.7605 17.1595 26.0945 17.3301 25.2481H26.1709C26.3777 26.2673 27.275 27 28.3155 27C29.3561 27 30.2533 26.2673 30.4601 25.2481H32.6922C32.8082 25.2481 32.9198 25.2022 33.0019 25.1201C33.084 25.0381 33.1299 24.9266 33.1299 24.8107V21.4895C33.1299 21.0466 33.0785 20.6048 32.9756 20.174L32.0193 16.1572C31.8541 15.3402 31.1374 14.7519 30.3025 14.7497H17.2063L16.4546 13.2417C16.3802 13.093 16.227 12.9989 16.0607 13H9.93333C9.76701 13 9.61602 13.0941 9.54162 13.2417L8.78773 14.7497H7.3073C7.06549 14.7497 6.86963 14.9455 6.86963 15.1872V24.8107C6.86963 24.9266 6.91558 25.0381 6.99765 25.1201C7.07971 25.2022 7.19149 25.2481 7.30748 25.2481ZM11.6842 26.123C11.1535 26.123 10.6743 25.8036 10.4708 25.3126C10.2683 24.8227 10.3799 24.2584 10.7552 23.8822C11.1316 23.5071 11.6962 23.3956 12.1864 23.5979C12.6777 23.8013 12.9972 24.2803 12.9972 24.8107C12.9972 25.5357 12.4096 26.123 11.6842 26.123ZM15.1856 26.123C14.6549 26.123 14.1756 25.8036 13.9721 25.3126C13.7697 24.8227 13.8813 24.2584 14.2566 23.8822C14.633 23.5071 15.1976 23.3956 15.6878 23.5979C16.1791 23.8013 16.4986 24.2803 16.4986 24.8107C16.4986 25.5357 15.911 26.123 15.1856 26.123ZM28.3157 26.123C27.785 26.123 27.3058 25.8036 27.1023 25.3126C26.8998 24.8227 27.0114 24.2584 27.3867 23.8822C27.7631 23.5071 28.3277 23.3956 28.8179 23.5979C29.3092 23.8013 29.6287 24.2803 29.6287 24.8107C29.6287 25.5357 29.0411 26.123 28.3157 26.123ZM32.1235 20.3763C32.1279 20.396 32.1301 20.4168 32.1344 20.4364H28.7535V17.3743H31.4102L32.1235 20.3763ZM10.2038 13.8749H15.7906L16.2283 14.7497H9.76614L10.2038 13.8749ZM7.74521 15.6246H30.3027C30.7251 15.6268 31.0861 15.9286 31.1649 16.3431L31.2043 16.4995H7.74513L7.74521 15.6246ZM27.8781 17.3743V20.4365H25.2521V17.3743H27.8781ZM24.3767 17.3743V20.4365H21.7507V17.3743H24.3767ZM20.8753 17.3743V20.4365H18.2493V17.3743H20.8753ZM17.374 17.3743V20.4365H14.7479V17.3743H17.374ZM13.8726 17.3743V20.4365H11.2466V17.3743H13.8726ZM7.74521 17.3743H10.3712V20.4365H7.74521V17.3743ZM7.74521 23.0608H8.62055V22.1859H7.74521V21.3111H32.2439C32.246 21.3701 32.2548 21.4292 32.2548 21.4893V22.1859H31.3795V23.0608H32.2548V24.3731H30.4604C30.4604 24.3654 30.4549 24.3578 30.4538 24.3501C30.4264 24.2255 30.3882 24.1041 30.34 23.986C30.3225 23.9422 30.2995 23.905 30.2798 23.8646C30.2426 23.7847 30.2 23.7082 30.154 23.6327C30.1255 23.589 30.0938 23.5496 30.0632 23.5081C30.015 23.4435 29.9625 23.3801 29.9078 23.3211C29.8706 23.2817 29.8334 23.2456 29.794 23.2095C29.7349 23.1548 29.6737 23.1034 29.6091 23.0564C29.5653 23.0247 29.5216 22.9941 29.4778 22.9646V22.9657C29.4067 22.9219 29.3345 22.8825 29.259 22.8475C29.213 22.8257 29.167 22.8038 29.1189 22.7819V22.783C29.0336 22.7502 28.946 22.7229 28.8563 22.7021C28.8125 22.6912 28.771 22.6759 28.7272 22.6671C28.4536 22.6102 28.1702 22.6102 27.8956 22.6671C27.8518 22.6759 27.8081 22.6912 27.7665 22.7021C27.6779 22.7229 27.5903 22.7502 27.5039 22.783C27.4557 22.8027 27.4109 22.8268 27.3638 22.8486L27.3649 22.8475C27.2894 22.8825 27.2161 22.9219 27.1461 22.9657C27.1023 22.9941 27.0586 23.0247 27.0148 23.0575V23.0564C26.9502 23.1034 26.889 23.1548 26.8299 23.2095C26.7905 23.2456 26.7522 23.2817 26.7161 23.3211C26.6603 23.3801 26.6088 23.4435 26.5607 23.5081C26.5301 23.5496 26.4983 23.589 26.4699 23.6327C26.4239 23.7082 26.3813 23.7847 26.3441 23.8646C26.3244 23.905 26.3003 23.9433 26.2839 23.986C26.2357 24.1041 26.1974 24.2255 26.1701 24.3501C26.1701 24.3578 26.1646 24.3654 26.1635 24.3731H17.3303C17.3303 24.3654 17.3248 24.3578 17.3237 24.3501C17.2963 24.2255 17.258 24.1041 17.2099 23.986C17.1924 23.9422 17.1694 23.905 17.1497 23.8646C17.1125 23.7847 17.0698 23.7082 17.0239 23.6327C16.9954 23.589 16.9637 23.5496 16.9331 23.5081C16.8849 23.4435 16.8324 23.3801 16.7777 23.3211C16.7405 23.2817 16.7033 23.2456 16.6639 23.2095C16.6048 23.1548 16.5435 23.1034 16.479 23.0564C16.4352 23.0247 16.3915 22.9941 16.3477 22.9646V22.9657C16.2766 22.9219 16.2044 22.8825 16.1289 22.8475C16.0829 22.8257 16.0369 22.8038 15.9888 22.7819V22.783C15.9045 22.7502 15.817 22.7229 15.7284 22.7021C15.6846 22.6912 15.643 22.6759 15.5971 22.6671C15.329 22.6113 15.0522 22.6113 14.783 22.6671C14.7601 22.6715 14.7393 22.6748 14.7152 22.6791C14.5937 22.7054 14.4745 22.7426 14.3596 22.7896L14.295 22.818C14.1791 22.8683 14.0685 22.9285 13.9635 22.9974L13.946 23.0105V23.0116C13.8464 23.0805 13.7512 23.1581 13.6648 23.2434C13.6506 23.2565 13.6363 23.2697 13.621 23.2839C13.5543 23.3517 13.4919 23.4228 13.435 23.4982C13.3759 23.4217 13.3125 23.3484 13.2446 23.2795C13.2304 23.2653 13.2162 23.2533 13.2009 23.239C13.1133 23.1537 13.0192 23.0761 12.9186 23.0072L12.9011 22.9941V22.993C12.796 22.9241 12.6855 22.8639 12.5706 22.8136L12.5061 22.7852H12.505C12.3901 22.7382 12.2708 22.701 12.1494 22.6748C12.1275 22.6704 12.1056 22.6671 12.0815 22.6627C11.8134 22.607 11.5355 22.607 11.2675 22.6627C11.2237 22.6715 11.1799 22.6868 11.1384 22.6977C11.0486 22.7185 10.9611 22.7458 10.8757 22.7787C10.8276 22.7983 10.7827 22.8224 10.7357 22.8443V22.8432C10.6613 22.8782 10.5891 22.9175 10.519 22.9613C10.4753 22.9897 10.4315 23.0203 10.3877 23.0531V23.052C10.3232 23.0991 10.2619 23.1505 10.2028 23.2051C10.1634 23.2412 10.1251 23.2773 10.089 23.3167C10.0343 23.3757 9.9829 23.4392 9.93366 23.5037C9.90302 23.5453 9.87129 23.5846 9.84284 23.6284H9.84394C9.79689 23.7038 9.75421 23.7804 9.71701 23.8602C9.69732 23.9007 9.67324 23.9389 9.65683 23.9816C9.60869 24.0997 9.57039 24.2211 9.54413 24.3458C9.54413 24.3534 9.53866 24.3611 9.53757 24.3687H7.74532L7.74521 23.0608Z" fill="#F7D4C4"/>
					<path d="M17.374 22.1859H26.1274V23.0613H17.374V22.1859Z" fill="#F7D4C4"/>
					</svg>
				</span>
				<span class="text">Mobile Location</span>
				</li>
				<li>
				<span>
					<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
					<rect width="40" height="40" rx="20" fill="#DBD7CF"/>
					<path d="M7.30748 25.2481H9.53962C9.71031 26.0945 10.3635 26.7605 11.2071 26.9464C12.0497 27.1334 12.9239 26.8043 13.4349 26.1098C13.9459 26.8043 14.8201 27.1334 15.6626 26.9464C16.5062 26.7605 17.1595 26.0945 17.3301 25.2481H26.1709C26.3777 26.2673 27.275 27 28.3155 27C29.3561 27 30.2533 26.2673 30.4601 25.2481H32.6922C32.8082 25.2481 32.9198 25.2022 33.0019 25.1201C33.084 25.0381 33.1299 24.9266 33.1299 24.8107V21.4895C33.1299 21.0466 33.0785 20.6048 32.9756 20.174L32.0193 16.1572C31.8541 15.3402 31.1374 14.7519 30.3025 14.7497H17.2063L16.4546 13.2417C16.3802 13.093 16.227 12.9989 16.0607 13H9.93333C9.76701 13 9.61602 13.0941 9.54162 13.2417L8.78773 14.7497H7.3073C7.06549 14.7497 6.86963 14.9455 6.86963 15.1872V24.8107C6.86963 24.9266 6.91558 25.0381 6.99765 25.1201C7.07971 25.2022 7.19149 25.2481 7.30748 25.2481ZM11.6842 26.123C11.1535 26.123 10.6743 25.8036 10.4708 25.3126C10.2683 24.8227 10.3799 24.2584 10.7552 23.8822C11.1316 23.5071 11.6962 23.3956 12.1864 23.5979C12.6777 23.8013 12.9972 24.2803 12.9972 24.8107C12.9972 25.5357 12.4096 26.123 11.6842 26.123ZM15.1856 26.123C14.6549 26.123 14.1756 25.8036 13.9721 25.3126C13.7697 24.8227 13.8813 24.2584 14.2566 23.8822C14.633 23.5071 15.1976 23.3956 15.6878 23.5979C16.1791 23.8013 16.4986 24.2803 16.4986 24.8107C16.4986 25.5357 15.911 26.123 15.1856 26.123ZM28.3157 26.123C27.785 26.123 27.3058 25.8036 27.1023 25.3126C26.8998 24.8227 27.0114 24.2584 27.3867 23.8822C27.7631 23.5071 28.3277 23.3956 28.8179 23.5979C29.3092 23.8013 29.6287 24.2803 29.6287 24.8107C29.6287 25.5357 29.0411 26.123 28.3157 26.123ZM32.1235 20.3763C32.1279 20.396 32.1301 20.4168 32.1344 20.4364H28.7535V17.3743H31.4102L32.1235 20.3763ZM10.2038 13.8749H15.7906L16.2283 14.7497H9.76614L10.2038 13.8749ZM7.74521 15.6246H30.3027C30.7251 15.6268 31.0861 15.9286 31.1649 16.3431L31.2043 16.4995H7.74513L7.74521 15.6246ZM27.8781 17.3743V20.4365H25.2521V17.3743H27.8781ZM24.3767 17.3743V20.4365H21.7507V17.3743H24.3767ZM20.8753 17.3743V20.4365H18.2493V17.3743H20.8753ZM17.374 17.3743V20.4365H14.7479V17.3743H17.374ZM13.8726 17.3743V20.4365H11.2466V17.3743H13.8726ZM7.74521 17.3743H10.3712V20.4365H7.74521V17.3743ZM7.74521 23.0608H8.62055V22.1859H7.74521V21.3111H32.2439C32.246 21.3701 32.2548 21.4292 32.2548 21.4893V22.1859H31.3795V23.0608H32.2548V24.3731H30.4604C30.4604 24.3654 30.4549 24.3578 30.4538 24.3501C30.4264 24.2255 30.3882 24.1041 30.34 23.986C30.3225 23.9422 30.2995 23.905 30.2798 23.8646C30.2426 23.7847 30.2 23.7082 30.154 23.6327C30.1255 23.589 30.0938 23.5496 30.0632 23.5081C30.015 23.4435 29.9625 23.3801 29.9078 23.3211C29.8706 23.2817 29.8334 23.2456 29.794 23.2095C29.7349 23.1548 29.6737 23.1034 29.6091 23.0564C29.5653 23.0247 29.5216 22.9941 29.4778 22.9646V22.9657C29.4067 22.9219 29.3345 22.8825 29.259 22.8475C29.213 22.8257 29.167 22.8038 29.1189 22.7819V22.783C29.0336 22.7502 28.946 22.7229 28.8563 22.7021C28.8125 22.6912 28.771 22.6759 28.7272 22.6671C28.4536 22.6102 28.1702 22.6102 27.8956 22.6671C27.8518 22.6759 27.8081 22.6912 27.7665 22.7021C27.6779 22.7229 27.5903 22.7502 27.5039 22.783C27.4557 22.8027 27.4109 22.8268 27.3638 22.8486L27.3649 22.8475C27.2894 22.8825 27.2161 22.9219 27.1461 22.9657C27.1023 22.9941 27.0586 23.0247 27.0148 23.0575V23.0564C26.9502 23.1034 26.889 23.1548 26.8299 23.2095C26.7905 23.2456 26.7522 23.2817 26.7161 23.3211C26.6603 23.3801 26.6088 23.4435 26.5607 23.5081C26.5301 23.5496 26.4983 23.589 26.4699 23.6327C26.4239 23.7082 26.3813 23.7847 26.3441 23.8646C26.3244 23.905 26.3003 23.9433 26.2839 23.986C26.2357 24.1041 26.1974 24.2255 26.1701 24.3501C26.1701 24.3578 26.1646 24.3654 26.1635 24.3731H17.3303C17.3303 24.3654 17.3248 24.3578 17.3237 24.3501C17.2963 24.2255 17.258 24.1041 17.2099 23.986C17.1924 23.9422 17.1694 23.905 17.1497 23.8646C17.1125 23.7847 17.0698 23.7082 17.0239 23.6327C16.9954 23.589 16.9637 23.5496 16.9331 23.5081C16.8849 23.4435 16.8324 23.3801 16.7777 23.3211C16.7405 23.2817 16.7033 23.2456 16.6639 23.2095C16.6048 23.1548 16.5435 23.1034 16.479 23.0564C16.4352 23.0247 16.3915 22.9941 16.3477 22.9646V22.9657C16.2766 22.9219 16.2044 22.8825 16.1289 22.8475C16.0829 22.8257 16.0369 22.8038 15.9888 22.7819V22.783C15.9045 22.7502 15.817 22.7229 15.7284 22.7021C15.6846 22.6912 15.643 22.6759 15.5971 22.6671C15.329 22.6113 15.0522 22.6113 14.783 22.6671C14.7601 22.6715 14.7393 22.6748 14.7152 22.6791C14.5937 22.7054 14.4745 22.7426 14.3596 22.7896L14.295 22.818C14.1791 22.8683 14.0685 22.9285 13.9635 22.9974L13.946 23.0105V23.0116C13.8464 23.0805 13.7512 23.1581 13.6648 23.2434C13.6506 23.2565 13.6363 23.2697 13.621 23.2839C13.5543 23.3517 13.4919 23.4228 13.435 23.4982C13.3759 23.4217 13.3125 23.3484 13.2446 23.2795C13.2304 23.2653 13.2162 23.2533 13.2009 23.239C13.1133 23.1537 13.0192 23.0761 12.9186 23.0072L12.9011 22.9941V22.993C12.796 22.9241 12.6855 22.8639 12.5706 22.8136L12.5061 22.7852H12.505C12.3901 22.7382 12.2708 22.701 12.1494 22.6748C12.1275 22.6704 12.1056 22.6671 12.0815 22.6627C11.8134 22.607 11.5355 22.607 11.2675 22.6627C11.2237 22.6715 11.1799 22.6868 11.1384 22.6977C11.0486 22.7185 10.9611 22.7458 10.8757 22.7787C10.8276 22.7983 10.7827 22.8224 10.7357 22.8443V22.8432C10.6613 22.8782 10.5891 22.9175 10.519 22.9613C10.4753 22.9897 10.4315 23.0203 10.3877 23.0531V23.052C10.3232 23.0991 10.2619 23.1505 10.2028 23.2051C10.1634 23.2412 10.1251 23.2773 10.089 23.3167C10.0343 23.3757 9.9829 23.4392 9.93366 23.5037C9.90302 23.5453 9.87129 23.5846 9.84284 23.6284H9.84394C9.79689 23.7038 9.75421 23.7804 9.71701 23.8602C9.69732 23.9007 9.67324 23.9389 9.65683 23.9816C9.60869 24.0997 9.57039 24.2211 9.54413 24.3458C9.54413 24.3534 9.53866 24.3611 9.53757 24.3687H7.74532L7.74521 23.0608Z" fill="#63313C"/>
					<path d="M17.374 22.1859H26.1274V23.0613H17.374V22.1859Z" fill="#63313C"/>
					</svg>
				</span>
				<span class="text">Upcoming Mobile Location</span>
				</li>
			</ul>
		`;
		map.controls[google.maps.ControlPosition.TOP_LEFT].push(pinLegendOverlay);
		// if (!isStaticMap) {
		this.map = map
		pagemap = map
		await this.initMarkers()
		// } else {
		// 	// Static Map
		// 	const { AdvancedMarkerElement } = await google.maps.importLibrary(
		// 		"marker"
		// 	)
		// 	const mappedMarkers = [...staticMarkers].map((markerEl) => {
		// 		if (
		// 			!markerEl &&
		// 			!parseFloat(markerEl.dataset.markerLat) &&
		// 			!parseFloat(markerEl.dataset.markerLng)
		// 		) {
		// 			return
		// 		}
		// 		const parser = new DOMParser()
		// 		const pinSvgString =
		// 			'<svg width="50" height="50" viewBox="0 0 66 66" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M48.4416 25.983C48.4416 28.7956 47.6896 31.4325 46.3758 33.7037H46.3827L46.261 33.8988C46.1617 34.0648 46.0593 34.2289 45.954 34.3908L34.7499 52.3461C33.9423 53.6403 32.0579 53.6403 31.2503 52.3461L20.0478 34.3934C19.9414 34.2297 19.8379 34.064 19.7376 33.8961L19.6175 33.7037H19.6244C18.3105 31.4325 17.5586 28.7956 17.5586 25.983C17.5586 17.4549 24.472 10.5415 33.0001 10.5415C41.5282 10.5415 48.4416 17.4549 48.4416 25.983ZM33.0001 33C36.4174 33 39.1876 30.2298 39.1876 26.8125C39.1876 23.3952 36.4174 20.625 33.0001 20.625C29.5828 20.625 26.8126 23.3952 26.8126 26.8125C26.8126 30.2298 29.5828 33 33.0001 33Z" fill="#0076BD" stroke="#051532" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
		// 		const pinSvg = parser.parseFromString(
		// 			pinSvgString,
		// 			"image/svg+xml"
		// 		).documentElement
		// 		let marker = new AdvancedMarkerElement({
		// 			map: map,
		// 			position: {
		// 				lat: parseFloat(markerEl.dataset.markerLat),
		// 				lng: parseFloat(markerEl.dataset.markerLng),
		// 			},
		// 			content: pinSvg,
		// 		})
		// 		return marker
		// 	})
		// 	this.centerMap(map, mappedMarkers)
		// }
	},

	async initMarkers() {
		const { AdvancedMarkerElement } = await google.maps.importLibrary("marker")
		const cardsEl = document.querySelector("#clinicMarkers");
		if (!cardsEl) return
		if (!document.querySelector("#clinicMarkers")) return
		const markersAll = document
			.querySelector("#clinicMarkers")
			.querySelectorAll(".clininc_map__marker")

		this.markers = []
		this.markerCluster?.clearMarkers()
		let validmarkers = [...markersAll]
			?.map((markerEl) => {
				if (
					markerEl &&
					parseFloat(markerEl.dataset.markerLat) &&
					parseFloat(markerEl.dataset.markerLng)
				) {
					let latLng = {
						lat: parseFloat(markerEl.dataset.markerLat),
						lng: parseFloat(markerEl.dataset.markerLng),
						id: markerEl.dataset.markerId,
						type: markerEl.dataset.markerType,
						add: markerEl.dataset.add,
						addurl: markerEl.dataset.addurl,
					}

					return latLng
				}
			})
			.filter((item) => item != undefined)

		let mappedMarketrs = validmarkers
			?.map((item) => {
				let latLng = {
					lat: parseFloat(item.lat),
					lng: parseFloat(item.lng),
					add: item.add,
					addurl: item.addurl,
				}
				if (latLng.lat && latLng.lng) {
					const parser = new DOMParser();

					const defaultmarkerpin =`<svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg"><path  fill-rule="evenodd" clip-rule="evenodd" d="M36.6982 19.6841C36.6982 21.8148 36.1285 23.8125 35.1332 25.5331H35.1384L35.0462 25.6809C34.971 25.8066 34.8934 25.931 34.8136 26.0536L26.3257 39.6561C25.7139 40.6366 24.2863 40.6366 23.6745 39.6561L15.1877 26.0556C15.1071 25.9316 15.0287 25.806 14.9527 25.6788L14.8617 25.5331H14.867C13.8716 23.8125 13.302 21.8148 13.302 19.6841C13.302 13.2234 18.5394 7.98596 25.0001 7.98596C31.4608 7.98596 36.6982 13.2234 36.6982 19.6841ZM25.0001 25C27.5889 25 29.6876 22.9013 29.6876 20.3125C29.6876 17.7236 27.5889 15.625 25.0001 15.625C22.4112 15.625 20.3126 17.7236 20.3126 20.3125C20.3126 22.9013 22.4112 25 25.0001 25Z" fill="#63313C" stroke="white" stroke-width="1.51515" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
					const fixedmarkerpin = `<svg  width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg"><path  d="M24.5 9C30.8512 9 35.9999 14.1142 36 20.4229C36 22.5042 35.4371 24.4542 34.458 26.1348H34.4658L34.3613 26.2998C34.3253 26.3594 34.2871 26.4177 34.25 26.4766L24.499 42L14.5322 26.1348H14.542C13.5629 24.4542 13 22.5042 13 20.4229C13.0001 14.1142 18.1488 9 24.5 9Z" fill="#E2A4DF"/><path d="M24.5233 15.6462C22.578 15.6462 20.997 17.0776 20.997 18.8182C20.997 19.9059 21.4332 21.1477 22.1317 22.2436C21.4837 22.3909 20.9307 22.5988 20.5072 22.8567C20.0225 23.1522 19.6909 23.5377 19.6909 23.9874C19.6909 24.305 19.8588 24.5978 20.1235 24.8392C20.3883 25.0806 20.7531 25.2807 21.1888 25.4486C22.0602 25.7846 23.2305 25.9846 24.5232 25.9846C25.816 25.9846 26.9863 25.7846 27.8577 25.4486C28.2934 25.2807 28.6582 25.0806 28.9229 24.8392C29.1877 24.5978 29.3556 24.305 29.3556 23.9874C29.3556 23.4689 28.925 23.0434 28.3067 22.7282C28.2465 22.6914 28.172 22.679 28.1011 22.6942C28.0301 22.7093 27.9694 22.7502 27.9332 22.8071C27.8975 22.864 27.8893 22.9319 27.9118 22.9943C27.9337 23.0567 27.9837 23.1077 28.0495 23.1357C28.5832 23.4078 28.8332 23.7116 28.8332 23.9874C28.8332 24.1568 28.7454 24.3284 28.5475 24.5087C28.3495 24.6891 28.0449 24.8681 27.6536 25.0191C26.8705 25.321 25.7553 25.5147 24.5232 25.5147C23.291 25.5147 22.1758 25.321 21.3927 25.0191C21.0014 24.8681 20.6968 24.6891 20.4989 24.5087C20.3009 24.3284 20.2132 24.1568 20.2132 23.9874C20.2132 23.7479 20.3974 23.4918 20.8009 23.2458C21.1835 23.0127 21.7468 22.8062 22.4212 22.6657C22.9701 23.4207 23.6395 24.0815 24.3762 24.5344C24.465 24.5886 24.5813 24.5886 24.6701 24.5344C26.5689 23.3669 28.0494 20.8287 28.0494 18.8182C28.0494 17.0776 26.4685 15.6462 24.5231 15.6462L24.5233 15.6462ZM24.5233 16.1162C26.1845 16.1162 27.5272 17.3332 27.5272 18.8182C27.5272 20.5593 26.1615 22.9416 24.5233 24.0389C22.8852 22.9417 21.5194 20.5595 21.5194 18.8182C21.5194 17.3332 22.8622 16.1162 24.5233 16.1162ZM24.5233 17.056C23.4443 17.056 22.5643 17.8476 22.5643 18.8182C22.5643 19.7889 23.4443 20.5805 24.5233 20.5805C25.6024 20.5805 26.4824 19.7889 26.4824 18.8182C26.4824 17.8476 25.6024 17.056 24.5233 17.056ZM24.5233 17.5259C25.3197 17.5259 25.96 18.1019 25.96 18.8182C25.96 19.5346 25.3197 20.1106 24.5233 20.1106C23.727 20.1106 23.0867 19.5346 23.0867 18.8182C23.0867 18.1019 23.727 17.5259 24.5233 17.5259ZM27.3966 22.3427C27.2523 22.3427 27.1354 22.4478 27.1354 22.5777C27.1354 22.7076 27.2523 22.8126 27.3966 22.8126C27.541 22.8126 27.6579 22.7076 27.6579 22.5777C27.6579 22.4478 27.541 22.3427 27.3966 22.3427Z" fill="#63313C"/></svg>`;
					const mobilemarkerpin =`<svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M24.5 9C30.8512 9 35.9999 14.1142 36 20.4229C36 22.5042 35.4371 24.4542 34.458 26.1348H34.4658L34.3613 26.2998C34.3253 26.3594 34.2871 26.4177 34.25 26.4766L24.499 42L14.5322 26.1348H14.542C13.5629 24.4542 13 22.5042 13 20.4229C13.0001 14.1142 18.1488 9 24.5 9Z" fill="#D71F85"/>
								<path d="M17.5148 23.2446H18.731C18.824 23.7027 19.18 24.0631 19.6396 24.1638C20.0987 24.265 20.5751 24.0868 20.8535 23.711C21.1319 24.0868 21.6083 24.265 22.0674 24.1638C22.5271 24.0631 22.883 23.7027 22.976 23.2446H27.7933C27.9059 23.7962 28.3948 24.1928 28.9618 24.1928C29.5288 24.1928 30.0177 23.7962 30.1304 23.2446H31.3466C31.4098 23.2446 31.4706 23.2197 31.5154 23.1753C31.5601 23.1309 31.5851 23.0705 31.5851 23.0078V21.2103C31.5851 20.9706 31.5571 20.7314 31.501 20.4982L30.98 18.3241C30.8899 17.882 30.4994 17.5636 30.0445 17.5624H22.9085L22.4989 16.7462C22.4584 16.6657 22.3749 16.6148 22.2843 16.6154H18.9456C18.8549 16.6154 18.7727 16.6663 18.7321 16.7462L18.3213 17.5624H17.5147C17.3829 17.5624 17.2762 17.6683 17.2762 17.7991V23.0078C17.2762 23.0705 17.3012 23.1309 17.3459 23.1753C17.3907 23.2197 17.4516 23.2446 17.5148 23.2446ZM19.8996 23.7181C19.6104 23.7181 19.3493 23.5452 19.2384 23.2795C19.1281 23.0143 19.1889 22.7089 19.3934 22.5053C19.5985 22.3023 19.9061 22.2419 20.1732 22.3514C20.4409 22.4615 20.615 22.7207 20.615 23.0078C20.615 23.4002 20.2949 23.7181 19.8996 23.7181ZM21.8074 23.7181C21.5183 23.7181 21.2571 23.5452 21.1463 23.2795C21.036 23.0143 21.0968 22.7089 21.3013 22.5053C21.5064 22.3023 21.814 22.2419 22.0811 22.3514C22.3488 22.4615 22.5229 22.7207 22.5229 23.0078C22.5229 23.4002 22.2027 23.7181 21.8074 23.7181ZM28.9619 23.7181C28.6727 23.7181 28.4116 23.5452 28.3007 23.2795C28.1904 23.0143 28.2512 22.7089 28.4557 22.5053C28.6608 22.3023 28.9685 22.2419 29.2356 22.3514C29.5033 22.4615 29.6773 22.7207 29.6773 23.0078C29.6773 23.4002 29.3572 23.7181 28.9619 23.7181ZM31.0367 20.6077C31.0391 20.6184 31.0403 20.6296 31.0427 20.6403H29.2005V18.9829H30.6481L31.0367 20.6077ZM19.0929 17.0889H22.1371L22.3756 17.5624H18.8545L19.0929 17.0889ZM17.7533 18.0359H30.0446C30.2747 18.0371 30.4715 18.2004 30.5144 18.4248L30.5359 18.5094H17.7532L17.7533 18.0359ZM28.7234 18.9829V20.6403H27.2926V18.9829H28.7234ZM26.8156 18.9829V20.6403H25.3847V18.9829H26.8156ZM24.9077 18.9829V20.6403H23.4768V18.9829H24.9077ZM22.9999 18.9829V20.6403H21.569V18.9829H22.9999ZM21.092 18.9829V20.6403H19.6611V18.9829H21.092ZM17.7533 18.9829H19.1842V20.6403H17.7533V18.9829ZM17.7533 22.0607H18.2302V21.5872H17.7533V21.1137H31.1023C31.1035 21.1456 31.1083 21.1776 31.1083 21.2101V21.5872H30.6313V22.0607H31.1083V22.771H30.1305C30.1305 22.7668 30.1275 22.7627 30.1269 22.7585C30.112 22.6911 30.0912 22.6254 30.0649 22.5614C30.0554 22.5378 30.0429 22.5176 30.0321 22.4957C30.0119 22.4525 29.9886 22.4111 29.9636 22.3703C29.9481 22.3466 29.9308 22.3253 29.9141 22.3028C29.8879 22.2679 29.8592 22.2335 29.8294 22.2016C29.8092 22.1803 29.7889 22.1607 29.7674 22.1412C29.7352 22.1116 29.7018 22.0838 29.6667 22.0583C29.6428 22.0412 29.619 22.0246 29.5951 22.0086V22.0092C29.5564 21.9855 29.517 21.9642 29.4759 21.9453C29.4508 21.9334 29.4258 21.9216 29.3996 21.9098V21.9104C29.3531 21.8926 29.3054 21.8778 29.2565 21.8666C29.2326 21.8606 29.21 21.8524 29.1861 21.8476C29.0371 21.8168 28.8826 21.8168 28.733 21.8476C28.7091 21.8524 28.6853 21.8606 28.6626 21.8666C28.6143 21.8778 28.5667 21.8926 28.5196 21.9104C28.4933 21.921 28.4689 21.934 28.4432 21.9459L28.4438 21.9453C28.4027 21.9642 28.3628 21.9855 28.3246 22.0092C28.3007 22.0246 28.2769 22.0412 28.253 22.0589V22.0583C28.2179 22.0838 28.1845 22.1116 28.1523 22.1412C28.1308 22.1607 28.11 22.1803 28.0903 22.2016C28.0599 22.2335 28.0319 22.2679 28.0056 22.3028C27.9889 22.3253 27.9716 22.3466 27.9561 22.3703C27.9311 22.4111 27.9078 22.4525 27.8876 22.4957C27.8768 22.5176 27.8637 22.5384 27.8548 22.5614C27.8285 22.6254 27.8077 22.6911 27.7928 22.7585C27.7928 22.7627 27.7898 22.7668 27.7892 22.771H22.9761C22.9761 22.7668 22.9731 22.7627 22.9725 22.7585C22.9576 22.6911 22.9367 22.6254 22.9105 22.5614C22.9009 22.5378 22.8884 22.5176 22.8777 22.4957C22.8574 22.4525 22.8342 22.4111 22.8091 22.3703C22.7936 22.3466 22.7763 22.3253 22.7596 22.3028C22.7334 22.2679 22.7048 22.2335 22.675 22.2016C22.6547 22.1803 22.6344 22.1607 22.613 22.1412C22.5808 22.1116 22.5474 22.0838 22.5122 22.0583C22.4884 22.0412 22.4645 22.0246 22.4407 22.0086V22.0092C22.4019 21.9855 22.3626 21.9642 22.3214 21.9453C22.2964 21.9334 22.2713 21.9216 22.2451 21.9098V21.9104C22.1992 21.8926 22.1515 21.8778 22.1032 21.8666C22.0794 21.8606 22.0567 21.8524 22.0317 21.8476C21.8856 21.8174 21.7348 21.8174 21.5881 21.8476C21.5756 21.85 21.5643 21.8518 21.5511 21.8541C21.485 21.8683 21.42 21.8885 21.3574 21.9139L21.3222 21.9293C21.259 21.9565 21.1988 21.9891 21.1416 22.0264L21.132 22.0335V22.0341C21.0778 22.0714 21.0259 22.1134 20.9788 22.1595C20.971 22.1666 20.9633 22.1737 20.9549 22.1814C20.9186 22.2181 20.8846 22.2566 20.8536 22.2975C20.8214 22.256 20.7868 22.2164 20.7498 22.1791C20.7421 22.1714 20.7343 22.1649 20.726 22.1572C20.6783 22.111 20.627 22.069 20.5722 22.0317L20.5626 22.0246V22.024C20.5054 21.9867 20.4452 21.9542 20.3826 21.9269L20.3474 21.9115H20.3468C20.2842 21.8861 20.2192 21.866 20.153 21.8518C20.1411 21.8494 20.1292 21.8476 20.1161 21.8453C19.97 21.8151 19.8186 21.8151 19.6725 21.8453C19.6487 21.85 19.6248 21.8583 19.6022 21.8642C19.5533 21.8754 19.5056 21.8902 19.4591 21.908C19.4328 21.9186 19.4084 21.9317 19.3828 21.9435V21.9429C19.3422 21.9619 19.3029 21.9832 19.2647 22.0068C19.2409 22.0222 19.217 22.0388 19.1932 22.0566V22.056C19.158 22.0814 19.1246 22.1092 19.0924 22.1388C19.0709 22.1584 19.0501 22.1779 19.0304 22.1992C19.0006 22.2312 18.9726 22.2655 18.9457 22.3004C18.929 22.3229 18.9118 22.3442 18.8963 22.3679H18.8969C18.8712 22.4087 18.848 22.4502 18.8277 22.4934C18.817 22.5153 18.8038 22.536 18.7949 22.5591C18.7687 22.623 18.7478 22.6887 18.7335 22.7562C18.7335 22.7603 18.7305 22.7645 18.7299 22.7686H17.7533L17.7533 22.0607Z" fill="#F7D4C4"/>
								<path d="M23.0001 21.5872H27.7697V22.0609H23.0001V21.5872Z" fill="#F7D4C4"/>
									</svg>`;
					const upcomingmarkerpin =`<svg  width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path  d="M25 9C31.0751 9 35.9999 14.1142 36 20.4229C36 22.5042 35.461 24.4542 34.5244 26.1348H34.5322L34.4336 26.2969C34.3977 26.359 34.3603 26.4201 34.3232 26.4814L24.999 42L15.4658 26.1348H15.4756C14.539 24.4542 14 22.5042 14 20.4229C14.0001 14.1142 18.9249 9 25 9Z" fill="#EB4E27"/>
							<path d="M18.3185 23.2446H19.4819C19.5708 23.7027 19.9113 24.0631 20.351 24.1638C20.7901 24.265 21.2457 24.0868 21.5121 23.711C21.7784 24.0868 22.234 24.265 22.6732 24.1638C23.1128 24.0631 23.4533 23.7027 23.5423 23.2446H28.1501C28.2579 23.7962 28.7255 24.1928 29.2678 24.1928C29.8102 24.1928 30.2778 23.7962 30.3856 23.2446H31.549C31.6094 23.2446 31.6676 23.2197 31.7103 23.1753C31.7531 23.1309 31.7771 23.0705 31.7771 23.0078V21.2103C31.7771 20.9706 31.7503 20.7314 31.6967 20.4982L31.1982 18.3241C31.1121 17.882 30.7386 17.5636 30.3035 17.5624H23.4777L23.0859 16.7462C23.0472 16.6657 22.9673 16.6148 22.8806 16.6154H19.6871C19.6004 16.6154 19.5217 16.6663 19.4829 16.7462L19.09 17.5624H18.3184C18.1924 17.5624 18.0903 17.6683 18.0903 17.7991V23.0078C18.0903 23.0705 18.1142 23.1309 18.157 23.1753C18.1998 23.2197 18.258 23.2446 18.3185 23.2446ZM20.5996 23.7181C20.323 23.7181 20.0732 23.5452 19.9672 23.2795C19.8617 23.0143 19.9198 22.7089 20.1154 22.5053C20.3116 22.3023 20.6059 22.2419 20.8614 22.3514C21.1174 22.4615 21.284 22.7207 21.284 23.0078C21.284 23.4002 20.9777 23.7181 20.5996 23.7181ZM22.4245 23.7181C22.1479 23.7181 21.8981 23.5452 21.7921 23.2795C21.6866 23.0143 21.7447 22.7089 21.9403 22.5053C22.1365 22.3023 22.4308 22.2419 22.6863 22.3514C22.9423 22.4615 23.1089 22.7207 23.1089 23.0078C23.1089 23.4002 22.8026 23.7181 22.4245 23.7181ZM29.2679 23.7181C28.9913 23.7181 28.7415 23.5452 28.6355 23.2795C28.53 23.0143 28.5881 22.7089 28.7837 22.5053C28.9799 22.3023 29.2742 22.2419 29.5297 22.3514C29.7857 22.4615 29.9523 22.7207 29.9523 23.0078C29.9523 23.4002 29.646 23.7181 29.2679 23.7181ZM31.2525 20.6077C31.2548 20.6184 31.256 20.6296 31.2582 20.6403H29.4961V18.9829H30.8808L31.2525 20.6077ZM19.828 17.0889H22.7399L22.968 17.5624H19.5999L19.828 17.0889ZM18.5466 18.0359H30.3035C30.5237 18.0371 30.7119 18.2004 30.7529 18.4248L30.7734 18.5094H18.5466L18.5466 18.0359ZM29.0398 18.9829V20.6403H27.6711V18.9829H29.0398ZM27.2149 18.9829V20.6403H25.8462V18.9829H27.2149ZM25.39 18.9829V20.6403H24.0213V18.9829H25.39ZM23.5651 18.9829V20.6403H22.1964V18.9829H23.5651ZM21.7402 18.9829V20.6403H20.3715V18.9829H21.7402ZM18.5466 18.9829H19.9153V20.6403H18.5466V18.9829ZM18.5466 22.0607H19.0028V21.5872H18.5466V21.1137H31.3153C31.3164 21.1456 31.321 21.1776 31.321 21.2101V21.5872H30.8647V22.0607H31.321V22.771H30.3857C30.3857 22.7668 30.3829 22.7627 30.3823 22.7585C30.368 22.6911 30.3481 22.6254 30.323 22.5614C30.3139 22.5378 30.3019 22.5176 30.2916 22.4957C30.2722 22.4525 30.25 22.4111 30.226 22.3703C30.2112 22.3466 30.1947 22.3253 30.1787 22.3028C30.1536 22.2679 30.1262 22.2335 30.0977 22.2016C30.0783 22.1803 30.0589 22.1607 30.0384 22.1412C30.0076 22.1116 29.9757 22.0838 29.942 22.0583C29.9192 22.0412 29.8964 22.0246 29.8736 22.0086V22.0092C29.8365 21.9855 29.7989 21.9642 29.7595 21.9453C29.7356 21.9334 29.7116 21.9216 29.6865 21.9098V21.9104C29.6421 21.8926 29.5964 21.8778 29.5497 21.8666C29.5269 21.8606 29.5052 21.8524 29.4824 21.8476C29.3398 21.8168 29.1921 21.8168 29.049 21.8476C29.0261 21.8524 29.0033 21.8606 28.9817 21.8666C28.9355 21.8778 28.8898 21.8926 28.8448 21.9104C28.8197 21.921 28.7963 21.934 28.7718 21.9459L28.7724 21.9453C28.733 21.9642 28.6948 21.9855 28.6583 22.0092C28.6355 22.0246 28.6127 22.0412 28.5899 22.0589V22.0583C28.5562 22.0838 28.5243 22.1116 28.4935 22.1412C28.473 22.1607 28.453 22.1803 28.4342 22.2016C28.4051 22.2335 28.3783 22.2679 28.3532 22.3028C28.3372 22.3253 28.3207 22.3466 28.3059 22.3703C28.2819 22.4111 28.2597 22.4525 28.2403 22.4957C28.23 22.5176 28.2175 22.5384 28.2089 22.5614C28.1838 22.6254 28.1639 22.6911 28.1496 22.7585C28.1496 22.7627 28.1468 22.7668 28.1462 22.771H23.5423C23.5423 22.7668 23.5395 22.7627 23.5389 22.7585C23.5247 22.6911 23.5047 22.6254 23.4796 22.5614C23.4705 22.5378 23.4585 22.5176 23.4482 22.4957C23.4288 22.4525 23.4066 22.4111 23.3827 22.3703C23.3678 22.3466 23.3513 22.3253 23.3353 22.3028C23.3102 22.2679 23.2828 22.2335 23.2543 22.2016C23.2349 22.1803 23.2156 22.1607 23.195 22.1412C23.1642 22.1116 23.1323 22.0838 23.0986 22.0583C23.0758 22.0412 23.053 22.0246 23.0302 22.0086V22.0092C22.9931 21.9855 22.9555 21.9642 22.9162 21.9453C22.8922 21.9334 22.8683 21.9216 22.8432 21.9098V21.9104C22.7992 21.8926 22.7536 21.8778 22.7074 21.8666C22.6846 21.8606 22.663 21.8524 22.639 21.8476C22.4993 21.8174 22.355 21.8174 22.2147 21.8476C22.2027 21.85 22.1919 21.8518 22.1794 21.8541C22.1161 21.8683 22.0539 21.8885 21.994 21.9139L21.9604 21.9293C21.8999 21.9565 21.8423 21.9891 21.7876 22.0264L21.7785 22.0335V22.0341C21.7266 22.0714 21.6769 22.1134 21.6319 22.1595C21.6245 22.1666 21.6171 22.1737 21.6091 22.1814C21.5743 22.2181 21.5418 22.2566 21.5121 22.2975C21.4813 22.256 21.4483 22.2164 21.4129 22.1791C21.4055 22.1714 21.3981 22.1649 21.3901 22.1572C21.3445 22.111 21.2954 22.069 21.243 22.0317L21.2338 22.0246V22.024C21.1791 21.9867 21.1215 21.9542 21.0616 21.9269L21.028 21.9115H21.0274C20.9675 21.8861 20.9054 21.866 20.8421 21.8518C20.8306 21.8494 20.8192 21.8476 20.8067 21.8453C20.667 21.8151 20.5221 21.8151 20.3824 21.8453C20.3596 21.85 20.3368 21.8583 20.3151 21.8642C20.2684 21.8754 20.2227 21.8902 20.1783 21.908C20.1532 21.9186 20.1298 21.9317 20.1053 21.9435V21.9429C20.0665 21.9619 20.0288 21.9832 19.9923 22.0068C19.9695 22.0222 19.9467 22.0388 19.9239 22.0566V22.056C19.8903 22.0814 19.8583 22.1092 19.8275 22.1388C19.807 22.1584 19.787 22.1779 19.7682 22.1992C19.7397 22.2312 19.7129 22.2655 19.6872 22.3004C19.6713 22.3229 19.6547 22.3442 19.6399 22.3679H19.6405C19.616 22.4087 19.5937 22.4502 19.5743 22.4934C19.5641 22.5153 19.5515 22.536 19.543 22.5591C19.5179 22.623 19.4979 22.6887 19.4842 22.7562C19.4842 22.7603 19.4814 22.7645 19.4808 22.7686H18.5467L18.5466 22.0607Z" fill="#F7D4C4"/>
							<path d="M23.5653 21.5872H28.1275V22.0609H23.5653V21.5872Z" fill="#F7D4C4"/>
							</svg>
							`;
					// Mobile clinics without confirmed dates use a muted grey pin
					// (grey fill + plum glyph) to distinguish them from confirmed
					// mobile clinics (pink) and upcoming ones (orange).
					const mobileunconfirmedmarkerpin =`<svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M24.5 9C30.8512 9 35.9999 14.1142 36 20.4229C36 22.5042 35.4371 24.4542 34.458 26.1348H34.4658L34.3613 26.2998C34.3253 26.3594 34.2871 26.4177 34.25 26.4766L24.499 42L14.5322 26.1348H14.542C13.5629 24.4542 13 22.5042 13 20.4229C13.0001 14.1142 18.1488 9 24.5 9Z" fill="#DBD7CF"/>
								<path d="M17.5148 23.2446H18.731C18.824 23.7027 19.18 24.0631 19.6396 24.1638C20.0987 24.265 20.5751 24.0868 20.8535 23.711C21.1319 24.0868 21.6083 24.265 22.0674 24.1638C22.5271 24.0631 22.883 23.7027 22.976 23.2446H27.7933C27.9059 23.7962 28.3948 24.1928 28.9618 24.1928C29.5288 24.1928 30.0177 23.7962 30.1304 23.2446H31.3466C31.4098 23.2446 31.4706 23.2197 31.5154 23.1753C31.5601 23.1309 31.5851 23.0705 31.5851 23.0078V21.2103C31.5851 20.9706 31.5571 20.7314 31.501 20.4982L30.98 18.3241C30.8899 17.882 30.4994 17.5636 30.0445 17.5624H22.9085L22.4989 16.7462C22.4584 16.6657 22.3749 16.6148 22.2843 16.6154H18.9456C18.8549 16.6154 18.7727 16.6663 18.7321 16.7462L18.3213 17.5624H17.5147C17.3829 17.5624 17.2762 17.6683 17.2762 17.7991V23.0078C17.2762 23.0705 17.3012 23.1309 17.3459 23.1753C17.3907 23.2197 17.4516 23.2446 17.5148 23.2446ZM19.8996 23.7181C19.6104 23.7181 19.3493 23.5452 19.2384 23.2795C19.1281 23.0143 19.1889 22.7089 19.3934 22.5053C19.5985 22.3023 19.9061 22.2419 20.1732 22.3514C20.4409 22.4615 20.615 22.7207 20.615 23.0078C20.615 23.4002 20.2949 23.7181 19.8996 23.7181ZM21.8074 23.7181C21.5183 23.7181 21.2571 23.5452 21.1463 23.2795C21.036 23.0143 21.0968 22.7089 21.3013 22.5053C21.5064 22.3023 21.814 22.2419 22.0811 22.3514C22.3488 22.4615 22.5229 22.7207 22.5229 23.0078C22.5229 23.4002 22.2027 23.7181 21.8074 23.7181ZM28.9619 23.7181C28.6727 23.7181 28.4116 23.5452 28.3007 23.2795C28.1904 23.0143 28.2512 22.7089 28.4557 22.5053C28.6608 22.3023 28.9685 22.2419 29.2356 22.3514C29.5033 22.4615 29.6773 22.7207 29.6773 23.0078C29.6773 23.4002 29.3572 23.7181 28.9619 23.7181ZM31.0367 20.6077C31.0391 20.6184 31.0403 20.6296 31.0427 20.6403H29.2005V18.9829H30.6481L31.0367 20.6077ZM19.0929 17.0889H22.1371L22.3756 17.5624H18.8545L19.0929 17.0889ZM17.7533 18.0359H30.0446C30.2747 18.0371 30.4715 18.2004 30.5144 18.4248L30.5359 18.5094H17.7532L17.7533 18.0359ZM28.7234 18.9829V20.6403H27.2926V18.9829H28.7234ZM26.8156 18.9829V20.6403H25.3847V18.9829H26.8156ZM24.9077 18.9829V20.6403H23.4768V18.9829H24.9077ZM22.9999 18.9829V20.6403H21.569V18.9829H22.9999ZM21.092 18.9829V20.6403H19.6611V18.9829H21.092ZM17.7533 18.9829H19.1842V20.6403H17.7533V18.9829ZM17.7533 22.0607H18.2302V21.5872H17.7533V21.1137H31.1023C31.1035 21.1456 31.1083 21.1776 31.1083 21.2101V21.5872H30.6313V22.0607H31.1083V22.771H30.1305C30.1305 22.7668 30.1275 22.7627 30.1269 22.7585C30.112 22.6911 30.0912 22.6254 30.0649 22.5614C30.0554 22.5378 30.0429 22.5176 30.0321 22.4957C30.0119 22.4525 29.9886 22.4111 29.9636 22.3703C29.9481 22.3466 29.9308 22.3253 29.9141 22.3028C29.8879 22.2679 29.8592 22.2335 29.8294 22.2016C29.8092 22.1803 29.7889 22.1607 29.7674 22.1412C29.7352 22.1116 29.7018 22.0838 29.6667 22.0583C29.6428 22.0412 29.619 22.0246 29.5951 22.0086V22.0092C29.5564 21.9855 29.517 21.9642 29.4759 21.9453C29.4508 21.9334 29.4258 21.9216 29.3996 21.9098V21.9104C29.3531 21.8926 29.3054 21.8778 29.2565 21.8666C29.2326 21.8606 29.21 21.8524 29.1861 21.8476C29.0371 21.8168 28.8826 21.8168 28.733 21.8476C28.7091 21.8524 28.6853 21.8606 28.6626 21.8666C28.6143 21.8778 28.5667 21.8926 28.5196 21.9104C28.4933 21.921 28.4689 21.934 28.4432 21.9459L28.4438 21.9453C28.4027 21.9642 28.3628 21.9855 28.3246 22.0092C28.3007 22.0246 28.2769 22.0412 28.253 22.0589V22.0583C28.2179 22.0838 28.1845 22.1116 28.1523 22.1412C28.1308 22.1607 28.11 22.1803 28.0903 22.2016C28.0599 22.2335 28.0319 22.2679 28.0056 22.3028C27.9889 22.3253 27.9716 22.3466 27.9561 22.3703C27.9311 22.4111 27.9078 22.4525 27.8876 22.4957C27.8768 22.5176 27.8637 22.5384 27.8548 22.5614C27.8285 22.6254 27.8077 22.6911 27.7928 22.7585C27.7928 22.7627 27.7898 22.7668 27.7892 22.771H22.9761C22.9761 22.7668 22.9731 22.7627 22.9725 22.7585C22.9576 22.6911 22.9367 22.6254 22.9105 22.5614C22.9009 22.5378 22.8884 22.5176 22.8777 22.4957C22.8574 22.4525 22.8342 22.4111 22.8091 22.3703C22.7936 22.3466 22.7763 22.3253 22.7596 22.3028C22.7334 22.2679 22.7048 22.2335 22.675 22.2016C22.6547 22.1803 22.6344 22.1607 22.613 22.1412C22.5808 22.1116 22.5474 22.0838 22.5122 22.0583C22.4884 22.0412 22.4645 22.0246 22.4407 22.0086V22.0092C22.4019 21.9855 22.3626 21.9642 22.3214 21.9453C22.2964 21.9334 22.2713 21.9216 22.2451 21.9098V21.9104C22.1992 21.8926 22.1515 21.8778 22.1032 21.8666C22.0794 21.8606 22.0567 21.8524 22.0317 21.8476C21.8856 21.8174 21.7348 21.8174 21.5881 21.8476C21.5756 21.85 21.5643 21.8518 21.5511 21.8541C21.485 21.8683 21.42 21.8885 21.3574 21.9139L21.3222 21.9293C21.259 21.9565 21.1988 21.9891 21.1416 22.0264L21.132 22.0335V22.0341C21.0778 22.0714 21.0259 22.1134 20.9788 22.1595C20.971 22.1666 20.9633 22.1737 20.9549 22.1814C20.9186 22.2181 20.8846 22.2566 20.8536 22.2975C20.8214 22.256 20.7868 22.2164 20.7498 22.1791C20.7421 22.1714 20.7343 22.1649 20.726 22.1572C20.6783 22.111 20.627 22.069 20.5722 22.0317L20.5626 22.0246V22.024C20.5054 21.9867 20.4452 21.9542 20.3826 21.9269L20.3474 21.9115H20.3468C20.2842 21.8861 20.2192 21.866 20.153 21.8518C20.1411 21.8494 20.1292 21.8476 20.1161 21.8453C19.97 21.8151 19.8186 21.8151 19.6725 21.8453C19.6487 21.85 19.6248 21.8583 19.6022 21.8642C19.5533 21.8754 19.5056 21.8902 19.4591 21.908C19.4328 21.9186 19.4084 21.9317 19.3828 21.9435V21.9429C19.3422 21.9619 19.3029 21.9832 19.2647 22.0068C19.2409 22.0222 19.217 22.0388 19.1932 22.0566V22.056C19.158 22.0814 19.1246 22.1092 19.0924 22.1388C19.0709 22.1584 19.0501 22.1779 19.0304 22.1992C19.0006 22.2312 18.9726 22.2655 18.9457 22.3004C18.929 22.3229 18.9118 22.3442 18.8963 22.3679H18.8969C18.8712 22.4087 18.848 22.4502 18.8277 22.4934C18.817 22.5153 18.8038 22.536 18.7949 22.5591C18.7687 22.623 18.7478 22.6887 18.7335 22.7562C18.7335 22.7603 18.7305 22.7645 18.7299 22.7686H17.7533L17.7533 22.0607Z" fill="#63313C"/>
								<path d="M23.0001 21.5872H27.7697V22.0609H23.0001V21.5872Z" fill="#63313C"/>
									</svg>`;


					let pinSvgString;
					if(item.type == 'fixed'){
						pinSvgString = fixedmarkerpin;
					}
					if(item.type == 'mobile'){}
					switch (item.type) {
						case 'fixed':
							pinSvgString = fixedmarkerpin;
							break;
						case 'mobile':
							pinSvgString = mobilemarkerpin;
							break;
						case 'mobileunconfirmed':
							pinSvgString = mobileunconfirmedmarkerpin;
							break;
						case 'upcoming':
							pinSvgString = upcomingmarkerpin;
							break;
						default:
							pinSvgString = defaultmarkerpin;
							break;
					}
					const pinSvg = parser.parseFromString(
						pinSvgString,
						"image/svg+xml"
					).documentElement;

					pinSvg.classList.add(`marker-${item.type || 'default'}`);
					let marker = new AdvancedMarkerElement({
						map: pagemap,
						position: {
							lat: latLng.lat,
							lng: latLng.lng,
						},
						content: pinSvg,
					});

					const fullAddress =`<div class='py-6 pl-8 rounded-2xl text-plum max-w-sm type-sm font-sans pr-10 md:text-lg font-normal text-left'>
						<a class="hocus:cursor-pointer select-none outline-none" href="${latLng.addurl}" target="_blank">
							${latLng.add}
						</a>
					</div>`;

					marker.addListener("click", () => {
				        if (infoWindow) infoWindow.close();
						infoWindow = new google.maps.InfoWindow({
								content: fullAddress,
						});
						const cardsClinic = document.querySelector('#locationCards');
						if (cardsClinic) {
							const targetEl = cardsClinic.querySelector(`[data-clinic-id="${item.id}"]`);
							if (targetEl) {
								// remove all selected from cards
								const allClinics = cardsClinic.querySelectorAll('.clinic_location__card');
								allClinics.forEach(el=> {
									if(el.classList.contains('selected')){
										el.classList.remove('selected')
									}
								})
								// add selected for clicked
								const alpineData = Alpine.$data(targetEl);
								targetEl.classList.add('selected');
								alpineData.openInfo = true;
								// Calculate the offset of the target element relative to the container
								const elementRect = targetEl.getBoundingClientRect();
								const parentContainerRect = cardsClinic.getBoundingClientRect();
								const scrollTopOffset = elementRect.top - parentContainerRect.top + cardsClinic.scrollTop - 4;
								// Scroll the container to the target element
								cardsClinic.scrollTo({
									top: scrollTopOffset,
									behavior: "smooth"
								});
								// Optionally focus the target element
								targetEl.focus();
								// Open info window
								infoWindow.open(pagemap, marker);
							} else {
								// Scroll to top of the container if no target element is found
								cardsClinic.scrollTo({
									top: 0,
									behavior: "instant"
								});
							}
						}
					});
					return {
						id:item.id,
						marker:marker
					}
				}
			})
			.filter((item) => item != undefined);

		//Clustering
		let markerCluser = new MarkerClusterer({
			map: pagemap,
			markers: mappedMarketrs.map(item => item.marker),
		})
		// this.centerMap(pagemap, mappedMarketrs)
		this.markerCluster = markerCluser
		this.markersMappedForSidebar = mappedMarketrs
		this.markersMapped = mappedMarketrs.map(item => item.marker)
	},

	async init() {
		// Set location
		const searchParams = new URLSearchParams(window.location.search);
		if(searchParams.has('location')){
			this.location = searchParams.get('location');
			this.suburbInput = searchParams.get('location');
		}
		// set layout
		if(searchParams.has('layout')){
			this.layout = searchParams.get('layout');
		}
		// set service Type
		if(searchParams.has('type')){
			this.serviceType = searchParams.get('type');
		}
		// Get Locations
		await this.getData();
		// Deep-link support: `/our-locations/<clinic-slug>` should open that
		// clinic automatically. Expand the card as soon as the data renders;
		// the map is centred on it later, once the markers exist.
		this.pendingClinicSlug = this._getClinicSlugFromPath();
		if (this.pendingClinicSlug) {
			this.expandClinicCardFromUrl();
		}
		// No api key
		if (!GMAPS_PUBLIC_API_KEY) {
			console.info("Add google Api Key")
			return
		}
		google.maps.importLibrary("maps").then(async ({ Map }) => {
			const mapEL = document.querySelector(
				"#clinicMap"
			)
			if (!mapEL) return
			// AutoComplete
			await this.initAutocomplete()
			// Map
			await this.initMap(Map, mapEL);
			// zoom in for location
 	        if(this.location){
				 this.zoomoonMapView();
			}
			// Deep-link: markers are ready, so centre the map on the clinic
			// referenced in the URL (if any) and open its info window.
			this.focusClinicOnMapFromUrl();
			// Watch on location changes Postcode/Suburb -> Map Init Map and Zoom
			this.$watch("location", async (value) => {
				const mapEL = document.querySelector(
					"#clinicMap"
				);
				if (!mapEL) return;
				if(value){
					const searchParams = new URLSearchParams(window.location.search);
					const clinic__map_section = document.querySelector('.clinic__map_section');
					if(clinic__map_section){
						clinic__map_section.classList.add('--hassearchValue')
					}
					this.suburbInput = value;
					searchParams.set('location', value);
					window.history.pushState({
						searchParams:searchParams.toString()
					}, '',`?${searchParams.toString()}`)

					// await this.initMap(Map, mapEL);
					await this.getData();
					await this.initMarkers();
					this.zoomoonMapView();
				}else{
					const searchParams = new URLSearchParams(window.location.search);
					const clinic__map_section = document.querySelector('.clinic__map_section');
					if(clinic__map_section){
						clinic__map_section.classList.remove('--hassearchValue')
					}
					this.location = null;
					this.suburbInput = '';
					this.centerMap(pagemap, this.markersMapped);
					searchParams.delete('location');
					window.history.pushState({
						searchParams:searchParams.toString()
					}, '',`?${searchParams.toString()}`)
				}
			});

			// Watch on servicetype
			this.$watch('serviceType',async(value)=>{
				const mapEL = document.querySelector(
				"#clinicMap"
				);
				if (!mapEL) return;
				if(value){
					const searchParams = new URLSearchParams(window.location.search);
					searchParams.set('type', value); // update
					window.history.pushState({
					searchParams:searchParams.toString()
					}, '',`?${searchParams.toString()}`)
					await this.getData();
					await this.initMarkers();
					this.zoomoonMapView();
				}else{
					const searchParams = new URLSearchParams(window.location.search);
					searchParams.delete('type'); // remove
					window.history.pushState({
					searchParams:searchParams.toString()
					}, '',`?${searchParams.toString()}`)
				}
			})
		});
	},

	// async setStaticMap(mapEl) {
	// 	const { Map } = await google.maps.importLibrary("maps")
	// 	await this.initMap(Map, mapEl, true, {
	// 		disableDefaultUI: true,
	// 		gestureHandling: "none",
	// 		zoom:16
	// 	})
	// },
	// async reRenderMarkers() {
	// 	this.markers = []
	// 	this.markerCluster?.clearMarkers()
	// 	await this.initMarkers()
	// },

	// async handleSpecFilter() {
	// 	// Reset List Scroll
	// 	const cardsEl = document.querySelector("#CollectionCentresCards")
	// 	if (cardsEl) {
	// 		cardsEl.scrollTo({
	// 			top: 0,
	// 			behavior: "instant",
	// 		})
	// 	}
	// 	// If spec is selected and not empty
	// 	if (this.selectedSpecialisation && this.selectedSpecialisation != " ") {
	// 		// filter Based on spec slug
	// 		let mapperFilterSpec =
	// 			[...this.dataset].filter((item) => {
	// 				if (item?.testSpecialisationCategories?.length > 0) {
	// 					const mappedSlugs =
	// 						item?.testSpecialisationCategories?.map(
	// 							(item) => item.slug
	// 						)
	// 					return mappedSlugs.includes(this.selectedSpecialisation)
	// 				}
	// 				return false
	// 			}) ?? []
	// 		// If there is active Suburb
	// 		if (this.activeSuburb) {
	// 			mapperFilterSpec = mapperFilterSpec.sort((a, b) => {
	// 				let aDistance = this._getDistanceFromCard(a)
	// 				let bDistance = this._getDistanceFromCard(b)
	// 				if (aDistance < bDistance) {
	// 					return -1
	// 				}
	// 				if (aDistance > bDistance) {
	// 					return 1
	// 				}
	// 			})
	// 		}

	// 		this.filterdataset = mapperFilterSpec
	// 	} else {
	// 		let mapperFilterSpec2 = [...this.dataset]
	// 		if (this.activeSuburb) {
	// 			mapperFilterSpec2 = mapperFilterSpec2.sort((a, b) => {
	// 				let aDistance = this._getDistanceFromCard(a)
	// 				let bDistance = this._getDistanceFromCard(b)
	// 				if (aDistance < bDistance) {
	// 					return -1
	// 				}
	// 				if (aDistance > bDistance) {
	// 					return 1
	// 				}
	// 			})
	// 		}
	// 		this.filterdataset = mapperFilterSpec2
	// 	}
	// 	// Update Markers
	// 	await this.reRenderMarkers()
	// },

	async initAutocomplete() {
		if(this.sessionToken == null){
			const { AutocompleteSessionToken } = await google.maps.importLibrary("places");
			let sessionToken = new AutocompleteSessionToken();
		    this.sessionToken = sessionToken;
		}
	},
	// handleListingResizeView(){
    //     if(window.innerWidth < 768 ){
	// 		this.view =  'list'
	// 		window.localStorage.setItem("view", 'list');
	// 	}
	// },
	async handleLayout(value){
		this.layout = value;
		const searchParams = new URLSearchParams(window.location.search);
		searchParams.set('layout', value);
		window.history.pushState({
			searchParams:searchParams.toString()
		}, '',`?${searchParams.toString()}`)
	},
	zoomoonMapView() {
		const inputVal = this.location;
		const geocoder = new google.maps.Geocoder();

		console.log(inputVal);

		geocoder
			.geocode({
				address: `${inputVal}`,
				bounds:	SA_BOUNDS,
				componentRestrictions: { country: "au" },
		    })
			.then(({ results }) => {
				if (results[0]) {
					let place = results[0];

					// Update coordinates
					this.suburbLat = place.geometry.location.lat()
					this.suburbLng = place.geometry.location.lng()


					const sortebyDistanceDataset = [...this.data].sort(
						(a, b) => {
							let aDistance = this._getDistanceFromCard(a)
							let bDistance = this._getDistanceFromCard(b)
							if (aDistance < bDistance) {
								return -1
							}
							if (aDistance > bDistance) {
								return 1
							}
						}
					);


					// Re-order the list by distance within each group now that the
					// searched suburb's coordinates are known (keeps grouping).
					this.buildOrderedData();

					// Update markers -> Location Zoom
					let suburbLocation = {
						lat: place.geometry.location.lat(),
						lng: place.geometry.location.lng(),
					};
					if (suburbLocation.lat && suburbLocation.lng) {
						let bounds = new google.maps.LatLngBounds();
						let closestLocation = sortebyDistanceDataset
							.filter(
								(item) =>
									item.lat !== null && item.lng !== null
							)
							.reduce(function (prev, curr) {
								let currPos = {
									lat: curr.lat,
									lng: curr.lng,
								}
								let prevPos = {
									lat: prev.lat,
									lng: prev.lng,
								}


								let cpos =
								  new google.maps.geometry.spherical.computeDistanceBetween(
										suburbLocation,
										currPos
									)
								let ppos =
									new google.maps.geometry.spherical.computeDistanceBetween(
										suburbLocation,
										prevPos
									)
								return cpos < ppos ? curr : prev
							});


						console.log(closestLocation);

						bounds.extend({
							lat: closestLocation.lat,
							lng: closestLocation.lng,
						});
						if (!bounds.isEmpty()) {
							this.map?.fitBounds(bounds)
							this.map?.setZoom(
								Math.min(15, this.map?.getZoom())
							)
						} else {
							this.centerMap(pagemap, this.markersMapped)
						}
				    }
				}
			})
			.catch((err) => console.error("Geocoder failed due to: " + err))
			.finally(() => {
				// this.filterloading = false;
				// this.loading = false;
			})
	},
	autocompleteSelectFirst() {
		if (!this.autocompletePredictions) {
			return
		}
		let firstPlace = this.autocompletePredictions[0]?.text;
		firstPlace = firstPlace.replace(/<(.|\n)*?>/g, '');  // Sanitize
		this.autocompleteSelectLocation(firstPlace)
	},
	autocompleteSelectLocation(id) {
		this.autocompleteShowPredictions = false
		const geocoder = new google.maps.Geocoder()
		if (!id) return
		this.filterloading = true;
		id = id.replace(/<(.|\n)*?>/g, '');  // Sanitize
		geocoder
			.geocode({
				address: `${id}`,
				bounds:	SA_BOUNDS,
				componentRestrictions: { country: "au" },
		    })
			.then(({ results }) => {
				if (results[0]) {
					let place = results[0];

					// Update coordinates
					this.suburbLat = place.geometry.location.lat()
					this.suburbLng = place.geometry.location.lng();


					// Now update lcocation
				    this.location = id;

					const sortebyDistanceDataset = [...this.data].sort(
						(a, b) => {
							let aDistance = this._getDistanceFromCard(a)
							let bDistance = this._getDistanceFromCard(b)
							if (aDistance < bDistance) {
								return -1
							}
							if (aDistance > bDistance) {
								return 1
							}
						}
					)
					// Reset Scroll
					const cardsEl = document.querySelector(
						"#locationCards"
					)
					if (cardsEl) {
						cardsEl.scrollTo({
							top: 0,
							behavior: "instant",
						})
					}
					// Sort Dataset
					this.filterdataset = sortebyDistanceDataset
					// Update markers -> Location Zoom
					let suburbLocation = {
						lat: place.geometry.location.lat(),
						lng: place.geometry.location.lng(),
					};
					console.log(suburbLocation);

					if (suburbLocation.lat && suburbLocation.lng) {
						let bounds = new google.maps.LatLngBounds();
						let closestLocation = sortebyDistanceDataset
							.filter(
								(item) =>
									item.lat !== null && item.lng !== null
							)
							.reduce(function (prev, curr) {
								let currPos = {
									lat: curr.lat,
									lng: curr.lng,
								}
								let prevPos = {
									lat: prev.lat,
									lng: prev.lng,
								}

								let cpos =
									google.maps.geometry.spherical.computeDistanceBetween(
										suburbLocation,
										currPos
									)
								let ppos =
									google.maps.geometry.spherical.computeDistanceBetween(
										suburbLocation,
										prevPos
									)
								return cpos < ppos ? curr : prev
							});
						bounds.extend({
							lat: closestLocation.lat,
							lng: closestLocation.lng,
						});
							if (!bounds.isEmpty()) {
								this.map?.fitBounds(bounds)
								this.map?.setZoom(
									Math.min(15, this.map?.getZoom())
								)
							} else {
								this.centerMap(pagemap, this.markersMapped)
							}
				    }
				}
			})
			.catch((err) => console.error("Geocoder failed due to: " + err))
			.finally(() => {
				// this.filterloading = false;
				// this.loading = false;
			})
	},
	async updateAutocomplete() {
		try {
			this.pageDataSearchLoading = true;
			const inputVal = this.suburbInput
			if (!inputVal) {
				console.warn("Nothing to search for!")
				await this.resetSuburb()
				return
			};

			let formattedPredictions = []
			if(inputVal &&  /^\d+\.?\d*$/.test(inputVal)){
					const foundSubuTags = 	availableTags.filter(item=> item.includes(`${inputVal}`)).map(item=> {
						return {
								id:item,
								text: item,
						}
					}) ?? [];
					formattedPredictions.push(...foundSubuTags)
			}else{
		    const { AutocompleteService } = await google.maps.importLibrary("places")
			const autocompleteService =  new AutocompleteService();
			let serviceOptions = {
				input: inputVal, // To get better prediction
				strictBounds: true,
				locationRestriction: SA_BOUNDS,
				componentRestrictions: { country: "au" },
				types: ["locality", "postal_code"],
			}
			if(this.sessionToken != null){
				serviceOptions.sessionToken =  this.sessionToken;
			}

			let result = await autocompleteService.getPlacePredictions(serviceOptions);
			if ("predictions" in result === false) {
				return;
			}

			result.predictions.forEach((p) => {
				let match = p.matched_substrings[0]
				let formattedDescription = []
				formattedDescription.push(p.description.substr(0, match.offset))
				formattedDescription.push(
					"<strong>" +
						p.description.substr(match.offset, match.length) +
						"</strong>"
				)
				formattedDescription.push(
					p.description.substr(match.offset + match.length)
				)

				formattedPredictions.push({
					id: p.place_id,
					text: formattedDescription
						.join("")
						.replace(", Australia", ""),
				})
			})
			}
			this.autocompletePredictions = formattedPredictions
		} catch (error) {
			console.error('Prediction Error', error)
		} finally {
			this.pageDataSearchLoading = false
		}
	},
	async resetSuburb() {
		this.suburbInput = ''
		this.location = null;
		this.autocompletePredictions = null;
		this.centerMap(pagemap, this.markersMapped);
		// reset lists back to the default grouped order (fixed -> upcoming -> other)
		this.suburbLat = null;
		this.suburbLng = null;
		this.buildOrderedData();
	},
	_getDistanceFromCard(el) {
		let lat = parseFloat(el?.lat),
			lng = parseFloat(el?.lng)

		return this._haversine_distance(
			{
				lat: lat,
				lng: lng,
			},
			{
				lat: this.suburbLat,
				lng: this.suburbLng,
			}
		)
	},
	// Deep-link: read the clinic slug from a `/our-locations/<slug>` URL.
	// Returns null when the path has no clinic segment.
	_getClinicSlugFromPath() {
		const segments = window.location.pathname.split('/').filter(Boolean);
		const base = segments.indexOf('our-locations');
		if (base === -1 || !segments[base + 1]) return null;
		return decodeURIComponent(segments[base + 1]);
	},
	// Deep-link: expand the clinic card matching `pendingClinicSlug` and scroll
	// it into view. Both the map sidebar and the list view render a card per
	// clinic, so expand every copy to cover whichever layout is active.
	expandClinicCardFromUrl() {
		const slug = this.pendingClinicSlug;
		if (!slug) return;
		const target = this.data.find((item) => item.slug === slug);
		if (!target) return;
		this.$nextTick(() => {
			const cards = document.querySelectorAll(
				`[data-clinic-id="${target.id}"]`
			);
			cards.forEach((card) => {
				const cardData = Alpine.$data(card);
				if (cardData) cardData.openInfo = true;
				if (card.classList.contains('clinic_location__card')) {
					card.classList.add('selected');
				}
			});
			// Scroll the visible card into view (sidebar scrolls internally;
			// the list view scrolls the page).
			const sidebar = document.querySelector('#locationCards');
			const sidebarCard = sidebar?.querySelector(
				`[data-clinic-id="${target.id}"]`
			);
			if (this.layout === 'map' && sidebar && sidebarCard) {
				const elementRect = sidebarCard.getBoundingClientRect();
				const parentRect = sidebar.getBoundingClientRect();
				const scrollTopOffset =
					elementRect.top - parentRect.top + sidebar.scrollTop - 4;
				sidebar.scrollTo({ top: scrollTopOffset, behavior: 'smooth' });
			} else {
				const visibleCard =
					[...cards].find((c) => c.offsetParent !== null) || cards[0];
				visibleCard?.scrollIntoView({
					behavior: 'smooth',
					block: 'center',
				});
			}
		});
	},
	// Deep-link: centre the map on `pendingClinicSlug` and open its info window.
	// Runs once the markers are ready; clears the pending slug so later
	// search/filter changes don't re-trigger it.
	focusClinicOnMapFromUrl() {
		const slug = this.pendingClinicSlug;
		if (!slug) return;
		const target = this.data.find((item) => item.slug === slug);
		this.pendingClinicSlug = null;
		if (!target) return;
		try {
			this.handleOnOpenSideBar(target, true);
		} catch (error) {
			console.error('Unable to focus clinic on map', error);
		}
	},
	handleOnOpenSideBar(data, openinfo){
		// duck legend
		if(openinfo == true){
			let bounds = new google.maps.LatLngBounds()
			let pt = new google.maps.LatLng(
				data.lat,
				data.lng
			)
			bounds.extend(pt);


			const listener = google.maps.event.addListenerOnce(pagemap, 'idle', () => {
			const currentZoom = pagemap.getZoom();
			// Pull back to ~16–17 for street-level context (adjust to taste: 15 = suburb, 16–17 = street/buildings, 18 = very close)
			if (currentZoom > 17) {
			pagemap.setZoom(17);
			}
			// Optional: gently re-center if needed
			// pagemap.panTo(pt);
		});pagemap?.fitBounds(bounds);

			const foundMarker = this.markersMappedForSidebar.find(item=>item.id == data.id);
			const fullAddress =`<div class='py-6 pl-8 rounded-2xl text-plum max-w-sm type-sm font-sans pr-10 md:text-lg font-normal text-left'>
						<a class="hocus:cursor-pointer select-none outline-none" href="${data.addressUrl}" target="_blank">
							${data?.addressLineOne ?? '' +' '+ data?.addressLineTwo ?? '' +' ' + data?.suburb ?? '' +' ' +data?.postcode ?? ''}
						</a>
					</div>`;
			if (infoWindow) infoWindow.close();
			infoWindow = new google.maps.InfoWindow({
					content: fullAddress,
			});
			infoWindow.open(pagemap, foundMarker.marker);
		}
	},
	centerMap(map, markers) {
		let bounds = new google.maps.LatLngBounds()
		markers.forEach((marker) => {
			let pt = new google.maps.LatLng(
				marker.position.lat,
				marker.position.lng
			)
			bounds.extend(pt)
		})
		if (!this.view == "map") return null;
		if (markers.length == 1) {
			map?.setCenter(bounds.getCenter())
		} else {
			map?.fitBounds(bounds)
		}
	},

	_haversine_distance(mk1, mk2) {
		const R = 3958.8 // Radius of the Earth in miles
		let rlat1 = mk1.lat * (Math.PI / 180) // Convert degrees to radians
		let rlat2 = mk2.lat * (Math.PI / 180) // Convert degrees to radians
		let difflat = rlat2 - rlat1 // Radian difference (latitudes)
		let difflon = (mk2.lng - mk1.lng) * (Math.PI / 180) // Radian difference (longitudes)

		let d =
			2 *
			R *
			Math.asin(
				Math.sqrt(
					Math.sin(difflat / 2) * Math.sin(difflat / 2) +
						Math.cos(rlat1) *
							Math.cos(rlat2) *
							Math.sin(difflon / 2) *
							Math.sin(difflon / 2)
				)
			)
		return d
	},
})


document.addEventListener("alpine:init", () => {
	Alpine.data("locationMap", locationMap)
})



export default locations;
